module.exports = __webpack_public_path__ + "img/progress_6.4d1b85f0.png";